// /Users/giovanny/euro-privilege-parceiros/frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import App from "./App";
import Consulta from "./components/consulta";
import AdminRoutes from "./components/admin"; // default export (AdminRoutes)
import CondoPortal from "./components/condo/CondoPortal";
import ProtectedRoute from "./components/ProtectedRoute";
import { installAuthFetch, clearSession } from "./auth";

installAuthFetch(() => {
  clearSession();
  window.location.replace("/");
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Login */}
        <Route path="/" element={<App />} />

        {/* Consulta */}
        <Route
          path="/consulta"
          element={
            <ProtectedRoute>
              <Consulta />
            </ProtectedRoute>
          }
        />

        {/* Área administrativa com rotas internas */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute role="admin">
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        {/* Portal do condomínio */}
        <Route
          path="/condo"
          element={
            <ProtectedRoute role="condo">
              <CondoPortal />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
